import { logFunctions as log } from "./Logging";

const CryptoJS = require("crypto-js");
const calculateHMACToken = (
  secretKey,
  sharedKey,
  orgID,
  date,
  method,
  path,
  correlation_id
) => {
  log.debug("+util_calculateHMACToken(TRACE)");
  log.info("util_calculateHMACToken() => orgID: %s, date: %s", orgID, date);
  const signature = calculateSignature(
    orgID,
    date,
    secretKey,
    method,
    path,
    correlation_id
  );
  const returnRes = `AccessKey ${sharedKey}:${signature}`;
  log.debug("-util_calculateHMAC(TRACE)");
  return returnRes;
};

const calculateSignature = function (
  orgID,
  date,
  secretKey,
  method,
  path,
  correlation_id
) {
  log.debug("+util_calculateHMACToken_calculateSignature(TRACE)");
  log.info("util_calculateHMACToken_calculateSignature() => date: %s", date);
  const key = uniqueKey(secretKey, date);
  const sc = signableContent(method, path, orgID, correlation_id);
  const hmac = CryptoJS.HmacSHA512(sc, key);
  log.info(
    "util_calculateHMACToken_calculateSignature() => signature calculated"
  );
  log.debug("-util_calculateHMACToken_calculateSignature(TRACE)");
  return CryptoJS.enc.Base64.stringify(hmac);
};

const uniqueKey = function (secretKey, date) {
  log.debug("+util_calculateHMACToken_uniqueKey(TRACE)");
  log.info("util_calculateHMACToken_uniqueKey() => date: %s", date);
  log.info("util_calculateHMACToken_uniqueKey => unique key generated");
  log.debug("-util_calculateHMACToken_uniqueKey(TRACE)");
  return CryptoJS.enc.Utf8.parse(secretKey + date);
};

const signableContent = function (method, path, orgID, correlation_id) {
  log.debug("+util_calculateHMACToken_signableContent(TRACE)");
  const params = [
    method,
    path,
    method === "GET" ? undefined : "application/json",
    undefined,
    correlation_id,
    orgID,
  ];
  log.info("util_calculateHMACToken_signableContent() => params: %o", params);
  log.debug("-util_calculateHMACToken_signableContent(TRACE)");
  return params.filter((p) => p && p.length > 0).join("\n");
};

export default calculateHMACToken;
export { calculateSignature, signableContent };
